import SelectBox, { Item, SelectBoxProps } from '@/components/select/SelectBox';
import { allUserRoles, formatUserRole } from '@/models/User';

type UserRoleSelectBoxProps<T extends Item> = SelectBoxProps<T> & {
  formatUserRole?: (role: string) => string;
  disabledRoles?: string[];
  showDisabled?: boolean;
};

export interface UserRoleItem extends Item {
  disabled?: boolean;
}

const UserRoleSelectBox = (props: UserRoleSelectBoxProps<UserRoleItem>) => {
  const {
    label = 'Role:',
    placeholder = 'Select role',
    formatUserRole: formatUserRoleProp,
    disabledRoles = [],
    showDisabled = false,
  } = props;

  const listUserRoles = (): Promise<UserRoleItem[]> => {
    return new Promise((resolve) => {
      let items: UserRoleItem[] = allUserRoles.map((role) => ({
        id: role,
        name: formatUserRoleProp ? formatUserRoleProp(role) : formatUserRole(role),
        disabled: disabledRoles.includes(role),
      }));

      if (!showDisabled) {
        items = items.filter((item) => !item.disabled);
      }

      resolve(items);
    });
  };

  return (
    <SelectBox<UserRoleItem>
      {...props}
      name="userRole"
      label={label}
      placeholder={placeholder}
      queryFn={listUserRoles}
      itemRender={(item: UserRoleItem, selected?: boolean) => (
        <span
          className={`
                        ${selected ? 'font-semibold' : 'font-normal'}
                        ${item.disabled ? 'opacity-50 cursor-not-allowed' : ''}
                        block truncate
                    `}
        >
          {item.name}
        </span>
      )}
    />
  );
};

export default UserRoleSelectBox;
